export const ADD_APPLICATIONS = 'ADD_APPLICATIONS'